<template>
    <main>
        <section class="hero">
            <div class="lg:tw-container tw-flex tw-flex-col lg:tw-flex-row lg:tw-justify-between lg:tw-gap-5">
                <div class="info lg:tw-pt-12">
                    <p class="tw-text-center lg:tw-text-left tw-text-white lg:tw-pb-6">Ebook Gratuito<br><span><i>"Aprenda a Negociar Forex"</i></span></p>
                    <h1 class="tw-hidden lg:tw-block lg:tw-text-left tw-text-white lg:tw-px-0 lg:tw-pb-10">Registe-se e <b>receba gratuitamente</b> um <b>Ebook</b>! Aprenda a investir de forma rápida e simples no maior mercado financeiro mundial.</h1>
                    <h2 class="tw-hidden lg:tw-block tw-text-white tw-text-2xl tw-text-left tw-font-bold">Agora pode investir com um preçário único</h2>
                    <ul class="tw-hidden lg:tw-block">
                        <li class="tw-text-left tw-text-white tw-relative tw-font-light tw-mb-2 tw-text-lg">EUR / USD spread de 0.55 pips</li>
                        <li class="tw-text-left tw-text-white tw-relative tw-font-light tw-mb-2 tw-text-lg">GBP / USD spread de 0.75 pips</li>
                        <li class="tw-text-left tw-text-white tw-relative tw-font-light tw-mb-2 tw-text-lg">USD / JPY spread de 0.65 pips</li>
                    </ul>
                </div>
                <div class="form-container tw-mt-3 lg:tw-mt-0 tw-relative">
                    <Form v-if="!$store.state.formSuccess" />
                    <FormSuccess v-if="$store.state.formSuccess" />
                </div>
            </div>
        </section>

        <section class="strategies">
            <div class="tw-container tw-py-5">
                <h1 class="tw-text-center tw-pb-6">Ebook - “Aprenda a Negociar Forex”</h1>
                <p class="tw-text-center tw-pb-8">Investir em Forex pode ser uma tarefa assustadora. <b>Onde começar? Que moedas comprar? Quanto investir?</b> Há muitas perguntas a serem feitas e respondidas. É por isso que criamos o Ebook “ Aprenda a Negociar Forex”. Este Ebook é ideal para os traders mais experientes e para investidores principiantes.</p>
                <p class="tw-text-center tw-pb-5 lg:tw-pb-auto"><b>Neste Ebook, disponibilizamos informações vitais para ajudá-lo na sua própria descoberta do mercado forex:</b></p>

                <div class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 lg:tw-gap-5 lg:tw-py-5">
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-1.svg">
                        <p>Obtenha uma <b>visão clara e concisa</b> do <b>mercado</b> Forex</p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-2.svg">
                        <p>Aprenda como <b>potenciar os seus investimentos</b> no maior mercado financeiro do mundo</p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-3.svg">
                        <p>Descubra as <b>informações chave</b> necessárias para começar a <b>investir</b></p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-4.svg">
                        <p>Aprenda passo a <b>passo como investir/negociar</b> com <b>exemplos práticos</b></p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-5.svg">
                        <p>Mais de 330 pares cambiais - <b>a maior oferta numa plataforma de trading</b></p>
                    </div>
                    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center lg:tw-flex-row lg:tw-justify-start">
                        <img src="~@/assets/img/icons/grid-6.svg">
                        <p><b>Stop Loss Garantido</b> para os principais activos financeiros</p>
                    </div>
                </div>
            </div>
        </section>

        <section class="free-ebook">
            <div class="tw-container tw-flex tw-flex-col tw-items-center tw-justify-center lg:tw-flex-row lg:tw-justify-between">
                <div><h1 class="tw-text-white tw-uppercase tw-text-center lg:tw-text-left tw-pb-4 lg:tw-pb-0">REGISTE-SE JÁ E RECEBA O SEU EBOOK GRÁTIS</h1></div>
                <div class="tw-flex tw-items-center tw-justify-center lg:tw-justify-end"><button v-scroll-to="'.hero'" class="btn-page tw-w-full lg:tw-w-auto tw-outline-none tw-text-white tw-text-center tw-uppercase">SAIBA MAIS ›</button></div>
            </div>
        </section>

        <section class="reasons tw-py-8 lg:tw-py-10">
            <div class="tw-container tw-flex tw-flex-col lg:tw-flex-row lg:tw-gap-10">
                <div>
                    <h2 class="tw-text-left tw-uppercase tw-pb-4 lg:tw-pb-0">PORQUÊ NEGOCIAR FOREX COM A INVEST BTRADER?</h2>
                    <ul>
                        <li class="tw-relative tw-pb-2"><b>Mais de 330 pares cambiais</b>, a maior oferta numa plataforma de trading</li>
                        <li class="tw-relative tw-pb-2"><b>Alavancagem dos Investimentos</b>, possibilidade de alavancar a sua carteira e efetuar cobertura de risco</li>
                        <li class="tw-relative tw-pb-2"><b>Negociação Contínua</b>, negoceie 24 horas por dia, 5 dias por semana</li>
                        <li class="tw-relative tw-pb-2"><b>O Mercado mais Popular</b>, liquidez elevada, mais de 5,3 triliões de USD por dia</li>
                        <li class="tw-relative tw-pb-2"><b>Stop Loss Garantido</b>, para os principais activos financeiros</li>
                    </ul>
                </div>
                <div class="tw-mt-3 lg:tw-mt-0">
                    <img src="~@/assets/img/section-img.png">
                </div>
            </div>
            <div class="tw-container tw-flex tw-items-center tw-justify-center tw-py-10">
                <button class="btn-page tw-text-center tw-mx-auto tw-uppercase tw-text-white" v-scroll-to="'.hero'">CRIAR CONTA GRÁTIS</button>
            </div>
        </section>

        <section class="caution tw-py-10 lg:tw-py-20">
            <div class="tw-container lg:tw-px-32 tw-flex tw-flex-col tw-justify-center tw-items-center lg:tw-flex-row lg:tw-justify-between">
                <div class="tw-pb-8 lg:tw-pb-0 tw-w-full">
                    <img src="~@/assets/img/alert.jpg">
                </div>
                <div class="lg:tw-px-12 tw-flex tw-flex-col tw-items-start tw-justify-center">
                    <h3 class="tw-uppercase tw-text-center lg:tw-text-left tw-pb-2">ADVERTÊNCIAS ESPECÍFICAS AO INVESTIDOR</h3>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">O indicador de risco resumido é uma guia do nível de risco deste produto comparado com outros produtos. Apresenta a probabilidade do produto perder dinheiro por causa dos movimentos nos mercados ou porque não temos capacidade para lhe pagar.</p>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">Este produto está classificado como 7 de 7, o que se traduz como a classe de risco mais elevada. Tal avalia as perdas potenciais de desempenho futuro a um nível extremamente elevado.</p>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">Os CFDs são produtos alanvancados que, dados os movimentos dos mercados subjacentes, podem produzir perdas muito rapidamente. Não existe proteção de capital contra risco de mercado, risco de crédito ou risco de liquidez.</p>
                    <p class="tw-text-center lg:tw-text-left tw-pb-4">Entre 57.4% e 70% das contas de investidores de retalho perdem dinheiro quando negoceiam CFD com estes fornecedores.</p>
                </div>
            </div>
        </section>
    </main>
</template>
<script>
import Form from '@/components/Form.vue';
import FormSuccess from '@/components/FormSuccess.vue';

export default {
    name: 'Home',
    components: {
        Form,
        FormSuccess,
    },
};
</script>
